export default "__VITE_ASSET__60e58981__"